import React, { useState, useEffect } from 'react';
import { obtenerProductos } from '../../../../services/productosService';
import { crearOrden } from '../../../../services/ordenesService';
import { useAuth } from '../../../../context/AuthContext';
import toast from 'react-hot-toast';

/**
 * Componente catálogo de productos
 * Muestra productos disponibles para compra
 */
const ProductCatalog = () => {
  const [productos, setProductos] = useState([]);
  const [loading, setLoading] = useState(true);
  const [processingPayment, setProcessingPayment] = useState(null);
  const { user } = useAuth();

  useEffect(() => {
    cargarProductos();
  }, []);

  const cargarProductos = async () => {
    try {
      setLoading(true);
      const data = await obtenerProductos();
      setProductos(data);
    } catch (error) {
      toast.error('Error al cargar productos');
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  const handleBuy = async (producto) => {
    if (!user) {
      toast.error('Debes iniciar sesión para comprar');
      return;
    }

    try {
      setProcessingPayment(producto.id);

      // Crear preferencia en Mercado Pago usando Edge Function
      const response = await fetch(
        `${process.env.REACT_APP_SUPABASE_URL}/functions/v1/create-preference`,
        {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${process.env.REACT_APP_SUPABASE_ANON_KEY}`
          },
          body: JSON.stringify({
            producto_id: producto.id,
            user_id: user.id
          })
        }
      );

      if (!response.ok) {
        throw new Error('Error al crear preferencia de pago');
      }

      const data = await response.json();

      // Crear orden en Supabase
      await crearOrden({
        user_id: user.id,
        producto_id: producto.id,
        monto: producto.precio,
        mp_preference_id: data.preferenceId,
        external_reference: `${user.id}_${producto.id}_${Date.now()}`
      });

      // Redirigir al checkout de Mercado Pago
      window.location.href = data.init_point;
    } catch (error) {
      toast.error('Error al iniciar el proceso de pago');
      console.error(error);
    } finally {
      setProcessingPayment(null);
    }
  };

  if (loading) {
    return <div className="text-center py-8">Cargando productos...</div>;
  }

  return (
    <div className="space-y-6">
      <h2 className="text-2xl font-bold text-gray-900">
        Catálogo de Productos
      </h2>

      {productos.length === 0 ? (
        <div className="text-center py-8 text-gray-500">
          No hay productos disponibles
        </div>
      ) : (
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {productos.map((producto) => (
            <div key={producto.id} className="bg-white shadow rounded-lg p-6">
              {producto.imagen_url && (
                <img
                  src={producto.imagen_url}
                  alt={producto.nombre}
                  className="w-full h-48 object-cover rounded-md mb-4"
                />
              )}
              <h3 className="text-lg font-medium text-gray-900 mb-2">
                {producto.nombre}
              </h3>
              {producto.descripcion && (
                <p className="text-sm text-gray-500 mb-4">
                  {producto.descripcion}
                </p>
              )}
              <div className="flex justify-between items-center">
                <span className="text-2xl font-bold text-gray-900">
                  ${Number(producto.precio).toFixed(2)}
                </span>
                <button
                  onClick={() => handleBuy(producto)}
                  disabled={processingPayment === producto.id}
                  className="px-4 py-2 border border-transparent rounded-md text-sm font-medium text-white bg-indigo-600 hover:bg-indigo-700 disabled:opacity-50 disabled:cursor-not-allowed"
                >
                  {processingPayment === producto.id ? 'Procesando...' : 'Comprar'}
                </button>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ProductCatalog;
